import React, { useState } from 'react';
import { assets } from '../../../../assets';
import { InfoIcon } from '../../../../components/ui-utils/info-icon';
import { PortfolioFundamental } from '../../../../logic/graphql/types/types';
import { InfoContainer, InfoContent } from '../components';
import InstrumentListItem from './instrument-list-item';
import CenteredSpinner from '../../../../components/loading-indicators/centered-spinner';
import { withErrorBoundary } from '@sentry/react';
import { Fallback } from '../../../../components/utils/error-boundary';
import { FormattedMessage } from 'react-intl';

const InstrumentList = (props: {
  data: PortfolioFundamental[];
  loading?: boolean;
}): JSX.Element => {
  const [isShowingInfo, setShowingInfo] = useState<boolean>(false);

  return (
    <section className="w-full">
      <div className="flex flex-row items-center mb-2">
        <h2 className="mr-2">
          <FormattedMessage id={'dashboardPage.instrumentList.title'} />
        </h2>
        <InfoIcon
          src={assets.icons.info_svg}
          alt="info"
          onClick={() => setShowingInfo(!isShowingInfo)}
        />
      </div>
      <InfoContainer visible={isShowingInfo}>
        <InfoContent />
      </InfoContainer>
      {props.loading ? (
        <CenteredSpinner />
      ) : (
        props.data.map((f: PortfolioFundamental, index: number) => (
          <InstrumentListItem key={index} fundamental={f} />
        ))
      )}
    </section>
  );
};

export default withErrorBoundary(InstrumentList, { fallback: Fallback });
